"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var randomString = function () {
    return Math.random()
        .toString(36)
        .substring(7)
        .split('')
        .join('.');
};
var ActionTypes = {
    SET_STATE: "@@icestore_SET_STATE" + randomString(),
};
exports.default = ActionTypes;
//# sourceMappingURL=actionTypes.js.map